export class ColorDropdown extends HTMLElement {
    #refs;
    constructor() {
        super();
        this.#refs = {
            items: Array.from(this.querySelectorAll('.configurator__color-item')),
            itemsAlt: Array.from(this.querySelectorAll('.configurator__section__color')),
            colorPanel: this.querySelector('[id*="ColorPanel"]'),
            colorPanelAlt: Array.from(this.querySelectorAll('[id*="ColorPanel"]')),
            version: '',
        };
        this.debug = {
            debugOn: false,
            consoleParent: 'background: #aaa; color: #fff; padding: 4px 10px;margin-top:20px;',
            consoleInfo: 'background: #ECBE13; color: #fff; padding: 4px 10px;',
            consoleParentTrue: 'background: #00C176; color: #fff; padding: 4px 10px;border-left:20px solid white;',
            consoleChildTrue: 'background: #00C176; color: #fff; padding: 4px 10px;border-left:40px solid white;',
            consoleClick: 'background: #3A89C9; color: #fff; padding: 4px 10px;border-left:40px solid white;',
        };
    }

    getVersion() {
        if (this.debug.debugOn) {
            console.log('%c getVersion() Called', this.debug.consoleParentTrue);
        }
        if (this.#refs.itemsAlt.length > 0) {
            this.#refs.version = 'old';
        } else {
            this.#refs.version = 'new';
        }
        if (this.debug.debugOn) {
            console.log('%c Color Dropdown Version: ' + this.#refs.version, this.debug.consoleChildTrue);
        }
    }

    getSelectedImage(data) {
        if (this.debug.debugOn) {
            console.log('%c getSelectedImage() Called', this.debug.consoleParentTrue);
        }
        // Check if a color is selected
        const selectedColor = data.filter(item => item.selected);
        if(selectedColor.length > 0) return selectedColor.image;
        return data[0].image;
    }

    checkSelectedColor(data) {
        if (this.debug.debugOn) {
            console.log('%c checkSelectedColor() Called', this.debug.consoleParentTrue);
        }
        const selectedColor = data.filter(item => item.selected);
        if(selectedColor.length > 0) return data;
        let isSelected = false;
        return data.map(item => {
            if(item.inStock && !isSelected) {
                item.selected = true;
                isSelected = true;
            }
            return item;
        });
    }

    hideColorPanel() {
        if (this.debug.debugOn) {
            console.log('%c hideColorPanel() Called', this.debug.consoleParentTrue);
        }
        this.#refs.colorPanel.classList.add('is-hidden');
    }

    fetchColorPanelData(cb) {
        if (this.debug.debugOn) {
            console.log('%c fetchColorPanelData() Called', this.debug.consoleParentTrue);
        }
        if (this.#refs.version === 'old') {
            let colorList = this.#refs.itemsAlt.map(el => {
                const selected = el.classList.contains('configurator__color-item--selected');
                const notInStockLabel = el.parentNode.querySelector('.disabled-div');
                const inStock = notInStockLabel ? false : true;
                const label = el.querySelector('.configurator__color__label') ?.innerText.replace(notInStockLabel, '');
                const value = el.querySelector('input[type="radio"]') ?.value;
                const image = el.querySelector('.configurator__color-image') ?.src;
                return { selected, label, value, image, notInStockLabel, inStock };
            });
            return cb(colorList);
        } else {
            const colorList = this.#refs.items.map(el => {
                const selected = el.classList.contains('configurator__color-item--selected');
                const notInStockLabel = el.querySelector('.configurator__color-link') ?.innerText;
                const inStock = notInStockLabel ? false : true;
                const label = el.querySelector('.configurator__color-label') ?.innerText.replace(notInStockLabel, '');
                const value = el.querySelector('input[type="hidden"]') ?.value;
                const image = el.querySelector('.configurator__color-image') ?.src;
                return { selected, label, value, image, notInStockLabel, inStock };
            });
            return cb(colorList);
        }
    }

    createDropdown(data) {
        if (this.debug.debugOn) {
            console.log('%c createDropdown() Called', this.debug.consoleParentTrue);
        }
        const template = this.createTemplate(data); 
        this.#refs.colorPanel.insertAdjacentHTML('beforebegin', template);
    }

    createTemplate(data) {
        if (this.debug.debugOn) {
            console.log('%c createTemplate() Called', this.debug.consoleParentTrue);
        }
        const options = this.createOptions(data);
        return `
            <div class="color_dropdown">
                <div class="form-select" data-select>
                    <select class="color_select">
                        ${options}
                    </select>
                </div>
            </div>
        `;
    }

    // Removed this line otherwise elements would not be selectable
    // ${ item.inStock ? '' : 'disabled' }  
    createOptions(data) {
        if (this.debug.debugOn) {
            console.log('%c createOptions() Called', this.debug.consoleParentTrue);
        }
        let optionTemplate = '';
        for (let item of data) {
            const option = `
            <option 
                value="${item.value}" 
                data-label="${item.label}" 
                data-image-url="${item.image}"
                ${item.selected ? 'selected' : ''} 
                ${item.inStock ? '' : 'data-sublabel="'+item.notInStockLabel+'"'}
            >
                ${item.label}
            </option>`;
            optionTemplate += option;
        }
        return optionTemplate;
    }

    preSelectOldColors() {
        if (this.debug.debugOn) {
            console.log('%c preSelectOldColors() Called', this.debug.consoleParentTrue);
        }
        if (this.#refs.version === 'old') {
            let colorOptions = document.querySelectorAll('.configurator__section__colors');
            colorOptions.forEach(colorOption => {
                colorOption.querySelector('input').click();
            });
        }
    }

    watchEvent() {
        if (this.debug.debugOn) {
            console.log('%c watchEvent() Called', this.debug.consoleParentTrue);
        }
        const selectElement = this.querySelector('.color_select');
        selectElement.addEventListener('change', this.updateValues.bind(this));
    }

    updateValues(e) {
        if (this.debug.debugOn) {
            console.log('%c updateValues() Called', this.debug.consoleParentTrue);
        }
        const controller = this.#refs.colorPanel.querySelector(`.configurator__color-item[data-color-value="${e.target.value}"]`);
        const controllerOld = this.querySelector(`.configurator__section__colors.is-hidden .configurator__section__color[data-valuecode="${e.target.value}"] input`);
        if (this.#refs.version === 'old') {
            controllerOld.click();
        } else {
            controller.click();
        }
    }

    get initialCheck() {
        if (this.debug.debugOn) {
            console.log('%c initialCheck() Called', this.debug.consoleParentTrue);
        }
        // Stop code if color panel is not found
        if(!this.#refs.colorPanel) return false;
        // Stop code if custom data attr is set to false
        if(!this.dataset.useDropdown || this.dataset.useDropdown.toLowerCase() === 'false') return false;
        return true;
    }

    copySidesButton() {
        if (this.debug.debugOn) {
            console.log('%c copySidesButton() Called', this.debug.consoleParentTrue);
        }
        let sideButtons = document.querySelectorAll('.configurator__section__fields__copy-values label');
        //console.log(sideButtons);
        sideButtons.forEach(sideButton => {
            sideButton.addEventListener('click', () => {
                // if the current state is checked, unchecked and vice-versa
                if (sideButton.parentNode.querySelector('input').checked) {
                    sideButton.parentNode.querySelector('input').checked = false;
                } else {
                    sideButton.parentNode.querySelector('input').checked = true;
                }
            });
        });
    }

    connectedCallback() {
        if (this.debug.debugOn) {
            console.log('%c connectedCallback() Color Dropdown Called', this.debug.consoleParent);
        }

        if (!this.initialCheck) return;
        // Hide color panel
        this.hideColorPanel();
        this.getVersion();
        if (this.#refs.version === 'old') {
            this.preSelectOldColors();
        }
        // fetch color panel data
        this.fetchColorPanelData(data => {
            // Check if a color is selected else select first color
            const colorData = this.checkSelectedColor(data);
            // Create dropdown
            this.createDropdown(colorData);
            // Watch event change on dropdown
            this.watchEvent();
        });

    }
}